/**
 * Created by decipaliz on 14.09.2022
 */

const Attention = cc.Sprite.extend({
    ctor: function (options) {
        options = options || {};

        this._super(options.image || bundles.attention.frames.attention_png);

        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(2);
    },

    setAmount: function (amount) {
        amount = amount || 0;

        this.setVisible(amount > 0);

        if (!this.amountText) {
            this.amountText = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.SMALL_WHITE_TEXT);
            this.addChild(this.amountText);
            this.amountText.setPosition(this.width / 2, this.height / 2);
        }
        this.amountText.setString(`${amount}`);
    },

    pulse: function () {
        if (this.baseScale === undefined) {
            this.baseScale = this.scale;
        }

        this.runAction(
            new cc.RepeatForever(
                new cc.Sequence(
                    new cc.ScaleTo(0.2, this.baseScale * 1.3).easing(cc.easeOut(2)),
                    new cc.ScaleTo(0.15, this.baseScale).easing(cc.easeIn(2)),
                    new cc.ScaleTo(0.2, this.baseScale * 1.2).easing(cc.easeOut(2)),
                    new cc.ScaleTo(0.15, this.baseScale).easing(cc.easeIn(2)),
                    new cc.DelayTime(3)
                )
            )
        );
    },

    jump: function () {
        if (this.baseScale === undefined) {
            this.baseScale = this.scale;
        }

        this.runAction(
            new cc.Repeat(
                new cc.Sequence(
                    new cc.ScaleTo(0.4, this.baseScale * 1.15).easing(cc.easeOut(2)),
                    new cc.ScaleTo(0.3, this.baseScale).easing(cc.easeIn(2))
                ),
                3
            )
        );
    }
});